import { TRIGGER_SWITCH_ACCOUNT_API, TRIGGER_SWITCH_ACCOUNT_API_SUCCESS } from 'redux/actionTypes';

export function triggerSwitchAccountApiCall(data, callback, stopLoader) {
	return {
		type: TRIGGER_SWITCH_ACCOUNT_API,
		data,
		stopLoader,
		callback,
	};
}

export function triggerSwitchAccountApiCallSuccess(data) {
	return {
		type: TRIGGER_SWITCH_ACCOUNT_API_SUCCESS,
		data,
	};
}
